import { defineComponent as _defineComponent } from 'vue'
import BCXPanel from '@/components/molecules/BCXPanel.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsPopup',
  props: {
  width: {
    type: String,
    default: '358px'
  },
  zIndex: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props;



const style = computed(() => {
  const style: Record<string, string | number> = {
    '--panel-width': props.width
  };
  if (props.zIndex) style.zIndex = props.zIndex;
  return style;
});


return { __sfc: true,props, style, BCXPanel }
}

})